var option_default = {
  "option": "IsLl1",
  "user_choice": "bFaJ4",
  "check": "H6kvE",
  "image": "AaL89",
  "input": "o1z64",
  "title": "_2TVbC",
  "centered": "KGDlD",
  "with_result": "pbcDT",
  "list": "VyfUi",
  "with_image": "-cY5q",
  "progress": "nh8Xo",
  "progress_value": "m2DtC",
  "label": "G1EYf",
  "cta": "Kt6Ep",
  "adornment_icon": "cLJND",
  "remove": "KolCj",
  "removeButton": "Cp17K",
  "removeButtonIcon": "XgKB-",
  "overlay": "WsCOq",
  "shown": "anS7X",
  "dark": "a2WOI",
  "spinner": "Knu-h",
  "spin": "Cx8Mi"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
